<template>
  <div class="feedback-container">
    <van-nav-bar :title="content.complain" left-arrow @click-left="onClickLeft" />
    <div class="feedback-container-p">
      <div class="feedback-form-item-p">
        <div class="feedback-form-item">{{ content.complainReason }}<em class="require">*</em></div>
        <div class="feedback-form-item">
          <van-radio-group v-model="reason">
            <van-radio v-for="item in radioList" :key="item.value" :name="item.value">{{ item.label }}</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="feedback-form-item-p">
        <div class="feedback-form-item">{{ content.complainContent }}<em class="require">*</em></div>
        <div class="feedback-form-item">
          <van-field
            v-model="desc"
            rows="5"
            type="textarea"
            maxlength="250"
            :placeholder="content.complainContentPlaceholder"
            show-word-limit
          />
        </div>
      </div>
      <div class="feedback-form-item-p">
        <div class="feedback-form-item1">
          <div>{{ content.complainImages }}<em class="require">*</em></div>
          <div>{{ fileList.length }} / {{ maxCount }}</div>
        </div>
        <div class="feedback-form-item">
          <upload
            :maxNum="maxCount"
            :pictureList="fileList"
            :maxSize="10"
            @success="uploadSuccess"
          ></upload>
        </div>
      </div>
      <div class="feedback-btn-p">
        <van-button type="info" round color="#1EAFFE" class="feedback-btn" @click="submit">{{ content.submitQuick }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 投诉页面
 */
import upload from '@/components/upload'
import { postAddComplain } from '@/models/common'
export default {
  components: {
    upload
  },
  data() {
    return {
      reason: '',
      desc: '',
      fileList: [], // 图片列表
      maxCount: 6, // 图片最大上传数量
      memberId: '',
      radioList: [
        {
          label: '欺诈',
          value: '欺诈'
        },
        {
          label: '色情低俗',
          value: '色情低俗'
        },
        {
          label: '诱导',
          value: '诱导'
        },
        {
          label: '传播不实信息',
          value: '传播不实信息'
        },
        {
          label: '违法犯罪',
          value: '违法犯罪'
        },
        {
          label: '骚扰',
          value: '骚扰'
        },
        {
          label: '侵权（诽谤、抄袭）',
          value: '侵权（诽谤、抄袭）'
        },
        {
          label: '混淆他人投诉',
          value: '混淆他人投诉'
        },
        {
          label: '恶意营销',
          value: '恶意营销'
        },
        {
          label: '其他',
          value: '其他'
        }
      ]
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    }
  },
  mounted(){
    // 若地址不传则先取缓存的，没缓存则默认游客
    if (localStorage.getItem('loginItem')) {
      this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
    } else {
      this.memberId = '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
    }
    this.initWxBtns()
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1)
    },
    // 上传成功
    uploadSuccess(imgList){
      this.fileList = [...imgList]
    },
    // 提交
    submit(){
      const _this = this
      if(this.memberId != '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        if(this.reason == ''){
          // 请选择投诉原因
          this.$toast(this.content.complainReason)
          return
        }
        if(this.desc == ''){
          // 请填写问题内容
          this.$toast(this.content.complainDescPlaceholder)
          return
        }
        if(this.fileList.length == 0){
          // 请上传至少一张截图
          this.$toast(this.content.complainImagesPlaceholder)
          return
        }
        let imgs = this.fileList.map(v=>v.url)
        postAddComplain({
          member_id: this.memberId,
          reason: this.reason,
          content: this.desc,
          images: imgs
        }).then(res=>{
          if(res.data.code == 0) {
            this.$toast(this.content.saveSuccess)
            this.resetForm()
            setTimeout(()=>{
              _this.onClickLeft()
            }, 500)
          }else {
            this.$toast(res.data.message)
          }
        })
      } else {
        // 游客模式不允许投诉
        this.$toast(this.content.feedbackFail)
      }
    },
    // 重置表单
    resetForm() {
      this.reason = this.radioList[0].value
      this.desc = ''
      this.fileList = []
    },
    // 初始化微信按钮
    initWxBtns() {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    }
  }
}
</script>

<style lang="less" scoped>
.feedback-container {
  //   position: relative;
  height: 100%;
  background-color: #f7f8fa;
  /deep/.van-nav-bar {
    background-color: #1EAFFE;
    .van-icon {
      color: #fff;
    }
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .feedback-container-p {
    max-height: calc(100% - 0.61333rem);
    overflow-y: auto;
    .feedback-form-item-p {
      margin-top: 0.2rem;
      padding: 0.21rem 0.21rem 0;
      background-color: #fff;
    }
    .feedback-form-item {
      font-size: 0.21rem;
      color: #333333;
      padding-bottom: 0.2rem;
      /deep/.van-cell {
        border: 1px solid #f2f2f2;
      }
      /deep/.van-radio {
        margin-bottom: 0.2rem;
      }
      .require {
        color: #c63e3a;
        font-style: normal;
        margin-left: 4px;
      }
    }
    .feedback-form-item1 {
      display: flex;
      justify-content: space-between;
      align-content: center;
      margin-bottom: 0.2rem;
      font-size: 0.21rem;
      .require {
        color: #c63e3a;
        font-style: normal;
        margin-left: 4px;
      }
    }
    .feedback-btn-p {
      margin-top: 0.4rem;
      padding-bottom: 0.2rem;
      text-align: center;
      .feedback-btn {
        width: 2.67rem;
        height: 0.5rem;
        //   font-size: 0.24rem;
      }
    }
  }
}
</style>
